export enum InquiryLane {
  lead = 'lead',
  contract = 'contract',
  offer = 'offer',
}
